import { Dispatch, createContext, useReducer } from "react";
import { LocationState, locationReducer, LocationReducerAction } from "../reducers/locationReducer";

interface LocationContextInterface {
  locationState: LocationState;
  locationDispatch: Dispatch<LocationReducerAction>;
}

export const LocationContext = createContext<LocationContextInterface>({ locationState: {}, locationDispatch: () => {} });

const LocationContextProvider = ({ children }: {children: JSX.Element}) => {
  const [ locationState, locationDispatch ] = useReducer(locationReducer, {});

  return (
    <LocationContext.Provider value={ { locationState, locationDispatch } }>
      { children }
    </LocationContext.Provider>
  );
};

export default LocationContextProvider;
